// extracted by mini-css-extract-plugin
export default {"info__container":"homeGaugeTable_info__container__oc8bV","flows__table":"homeGaugeTable_flows__table__r4e71","sort__header":"homeGaugeTable_sort__header__zMAjA"};